<template>
	<div class="container-print">
		<div v-if="boleto_flash == '1' && !(boleto_permitido.length == 1 && boleto_permitido[0] == 'PIX')">
			<a href="https://boletoflash.com/" target="_blank">
				<img class="logo-boleto-flash" src="~@/assets/img/logos/boleto_flash.svg">
			</a>
		</div>

		<div v-else>
			<img class="logo-pagbrasil mt-2" src="~@/assets/img/logos/pagbrasil.svg">
		</div>

		<button v-if="opcao_clicada !== 'PIX'" class="print-btn noprint" @click="printBoleto()">
			<inline-svg :src="require('@/assets/img/pbi/pbi_print_16.svg')" />
			<span>Imprimir</span>
		</button>
	</div>
</template>

<script>

import InlineSvg from "vue-inline-svg";

export default {
	name: 'CabecalhoFlashImpressao',

	components: {
		InlineSvg
	},

	computed: {
		boleto_flash(){
			return this.$store.state.boleto.boleto.flash;
		},

		boleto_permitido(){
			return this.$store.state.boleto.boleto_permitido;
		},

		opcao_clicada(){
			return this.$store.state.boleto.opt;
		},
	},

	methods: {
		printBoleto() {
			window.print();
		}
	}
}

</script>